import { css } from 'lit';
import { fsDesignToken } from '../../../core/style-util.js';

export const style = css`
  .loan-header {
    font-size: ${fsDesignToken('fsFontSizeMedium1')};
    font-weight: ${fsDesignToken('fsFontWeightSemibold')};
    margin-bottom: 0.5rem;
    margin-top: 2rem;
  }

  .grid {
    display: grid;
    flex-grow: 1;
    gap: 1rem;
    grid-auto-flow: row;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    margin-top: 1rem;

    @media (min-width: 768px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  .return-cta {
    margin-top: 1em;
    text-align: center;
  }

  .return-cta-button {
    margin: 0 auto;
  }

  .warning-container {
    text-align: center;
  }
`;
